/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Skill } from './';
import {
    SkillFromJSON,
    SkillFromJSONTyped,
    SkillToJSON,
} from './';

/**
 * 
 * @export
 * @interface SkillsResponse
 */
export interface SkillsResponse {
    /**
     * 
     * @type {Array<Skill>}
     * @memberof SkillsResponse
     */
    skills: Array<Skill>;
}

/**
 * Check if a given object implements the SkillsResponse interface.
 */
export function instanceOfSkillsResponse(value: object): value is SkillsResponse {
    if (!('skills' in value) || value['skills'] === undefined) return false;
    return true;
}

export function SkillsResponseFromJSON(json: any): SkillsResponse {
    return SkillsResponseFromJSONTyped(json, false);
}

export function SkillsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkillsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'skills': ((json['skills'] as Array<any>).map(SkillFromJSON)),
    };
}

export function SkillsResponseToJSON(value?: SkillsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'skills': ((value['skills'] as Array<any>).map((v) => SkillToJSON(v))),
    };
}

